export default String.raw`
<g id="06.-Lista-towarów" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="opis-copy" transform="translate(0.000000, 0.500000)">
        <rect id="Rectangle" class="bgColor" x="-19" y="-20" width="1083" height="245"></rect>
        <rect id="Rectangle" class="lightBorderColor--stroke" x="0.930469288" y="0" width="1040.61927" height="204"></rect>
        <g id="Group-26" transform="translate(20.000000, 96.500000)">
            <text id="Statystyczna-osoba-k" font-family="Roboto-Regular, Roboto" font-size="16" font-weight="normal" fill="#000000">
                <tspan x="146" y="17">Statystyczna osoba korzysta z telefonu nawet 4h dziennie. Dlatego wiemy jak ważne jest kupno solidnego</tspan>
                <tspan x="146" y="38">i sprawdzonego smartfona czy smartwatcha. Istniejemy na rynku kilkanaście lat. Doskonale znamy się na sprzęcie </tspan>
                <tspan x="146" y="59">multimedialnym. Nie ryzykuj, kup u nas.</tspan>
            </text>
            <image id="telefony-i-zegarki" x="0" y="0" width="118" height="78.175" href="./img/previewElements/categoryDescriptionDesktop_1.png"></image>
        </g>
        <text id="Telefony-i-zegarki" class="primaryColorFont" font-family="Roboto-Bold, Roboto" font-size="19" font-weight="bold">
            <tspan x="20" y="43.5">Telefony i zegarki</tspan>
        </text>
        <line class="lightBorderColor--stroke" x1="0.930469288" y1="68" x2="1041.54973" y2="68" id="Line" stroke-linecap="square"></line>
        <g transform="translate(1008, 2)">
            <use class="primaryColorFont primaryColorFont--stroke" xlink:href="#angle-up" width="48" height="48" transform="scale(10)"></use>
        </g>
    </g>
</g>
`;